import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useCountdown from "./useCountdown";

const CRIMSON = "#a31545";
const CRIMSON_DEEP = "#7d1733";

/**
 * Compact, in-flow happy-hour banner for the lobby. Renders a live "Nx active"
 * strip with a live countdown, or an "incoming" teaser strip, and opens the
 * matching modal on click.
 */
const HappyHourBanner = ({ status, onClick, onExpire }) => {
  const { t } = useTranslation();
  const live = !!status?.live;
  const initialSeconds = live
    ? Number(status?.secondsUntilEnd || 0)
    : Number(status?.secondsUntilStart || 0);
  const { human } = useCountdown(initialSeconds, onExpire);

  if (!status) return null;
  const multiplier = status.multiplier || status.coinMultiplier || 2;

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        background: live ? "#fdeef2" : "#fbe4ea",
        borderLeft: `5px solid ${CRIMSON}`,
        borderRadius: 2,
        px: 2,
        py: 1.25,
        mb: 2,
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(160deg, ${CRIMSON} 0%, ${CRIMSON_DEEP} 100%)`,
          color: "#fff",
          fontWeight: 900,
          fontSize: 18,
          borderRadius: 1.5,
          px: 1.25,
          py: 0.5,
          flexShrink: 0,
        }}
      >
        {multiplier}x
      </Box>
      <Stack sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 800, color: "#2b2b2b", lineHeight: 1.2 }}>
          {live ? t("happyHour.bannerActive") : t("happyHour.bannerIncoming")}
        </Typography>
        <Typography sx={{ fontSize: 12.5, color: CRIMSON, fontWeight: 600 }}>
          {live
            ? t("happyHour.bannerEndsIn", { time: human })
            : t("happyHour.bannerStartsIn", { time: human, multiplier })}
        </Typography>
      </Stack>
    </Box>
  );
};

export default HappyHourBanner;
